export default {
  bigTitle: 'Message Lookup',
  searchTip: 'Please enter the email and message number to query message details!',
  emailPlaceholder: 'Email',
  caseNumberPlaceholder: 'Case number',
  caseNumberTitle: 'Case Number',
  statusMap: {
    0: { text: 'Pending', color: 'orange' },
    1: { text: 'Processed', color: '#00a4ff' },
    5: { text: 'Finished', color: '#67c23a' },
  },
  tableTitle: 'Below are the details of the message:',
  tableHeadLabel: {
    type: 'Type',
    username: 'Name',
    company: 'Company',
    job: 'Job',
    phone: 'Phone',
    email: 'Email'
  },
  messageContentLabel: {
    time: 'Time',
    desc: 'Description',
    file: 'Attachments'
  },
  title01: 'Message reply',
  txt01: '',
  activeTips: 'If your problem has been handled and resolved, you can close this message!',
  closeBtnTxt: 'Close',
  addMessageBtnTxt: 'Comment',
  closeDialog: {
    title: 'Tips',
    tips: 'Are you sure you want to close this message?',
    cancalBtn: 'Cancel',
    confirmBtn: 'Confirm',
    successTip: 'Closed successfully!',
  },
  closedTips: {
    title: 'Closed successfully, Thank you for your feedback!',
    contactUsTxt: 'If you have any new questions, you can restart a message or contact Wuxi Kelke Customer Service Department:',
    contactUsList: [
      { label: 'Phone：', value: '+86-510-885882008', workingTime: '(Monday to Friday, 8:30am - 4:30pm)', icon: require("@/assets/images/callMe/phone_color_icon.png") },
      { label: 'Hotline：', value: '+86-189-6183-2100（24/7）', icon: require("@/assets/images/callMe/online_color_icon.png") },
      { label: 'Email：', value: 'info@kelkflow.com.cn', icon: require('@/assets/images/callMe/email_color_icon.png') },
    ],
  },
  textareaPlaceholder: 'Please write a description, and we will contact you as soon as possible.',
  submitBtnTxt: 'Submit',
  messageSubmitCheckTxt: {
    messageTips: 'Please fill in the message content',
    emailTips: 'Please enter your email address',
    caseNumberTips: 'Please enter message number',
    successTip: 'Message success!',
  }
}


// WEBPACK FOOTER //
// ./src/config/lang/en/messageRecord.js